import { component } from 'lucia/dist/legacy/lucia.esm';

const app = component({ count: 0 });
app.mount('#app');
